var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
import { NotificationFullSizeDto } from './notification.full-size.dto.js';
/**
 * One page of the Posteingang. Cursor-paged rather than offset-paged because a
 * fetch has side effects on the rows it returns (it marks them read, and from
 * RS-005 on it archives them), so an offset would step over rows the user never
 * saw. `nextCursor` is null on the last page.
 */
export class NotificationPageDto {
    items;
    nextCursor;
}
__decorate([
    Expose(),
    Type(() => NotificationFullSizeDto),
    __metadata("design:type", Array)
], NotificationPageDto.prototype, "items", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], NotificationPageDto.prototype, "nextCursor", void 0);
//# sourceMappingURL=notification-page.dto.js.map